var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoeing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.185,
    height: 13.215,
    viewBox: "0 0 16.185 13.215",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_40789",
    "data-name": "Path 40789",
    d: "M7.841,5.142h-3.9L2.553,3.605A1.466,1.466,0,0,0,.378,5.57l.891.986-.84.84A1.466,1.466,0,1,0,2.5,9.469l1.4-1.4H7.842L5.611,10.827a1.466,1.466,0,1,0,2.278,1.845l3.725-4.6h3.106a1.466,1.466,0,1,0,0-2.931H11.614L7.889.543A1.466,1.466,0,0,0,5.611,2.388Z",
    fill: "#6f6f6f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoeing);
export default __webpack_public_path__ + "static/media/boeing.719cb3b8.svg";
export { ForwardRef as ReactComponent };